export const resourceConfig = {
  link: 'resource',
  icon: 'media',
  tip: {
    chinese: '多媒体资源',
    english: 'resource',
  },
  uuid: 'RESOURCE',
  sub: [
    {
      link: 'image',
      icon: 'picture',
      tip: {
        chinese: '图片',
        english: 'image',
      },
      params: [
        { key: 'page', required: 'true', default: 1, type: 'query' },
        { key: 'subject', required: 'true', default: 'english', type: 'query' },
        { key: 'id', required: 'optional' },
      ],
    },
    {
      link: 'audio',
      icon: 'sound',
      tip: {
        chinese: '音频',
        english: 'audio',
      },
      params: [
        { key: 'page', required: 'true', default: 1, type: 'query' },
        { key: 'subject', required: 'true', default: 'english', type: 'query' },
        { key: 'id', required: 'optional' },
      ],
    },
    {
      link: 'video',
      icon: 'youtube',
      tip: {
        chinese: '视频',
        english: 'video',
      },
      params: [
        { key: 'page', required: 'true', default: 1, type: 'query' },
        { key: 'subject', required: 'true', default: 'english', type: 'query' },
        { key: 'id', required: 'optional' },
      ],
    },
    {
      link: 'document',
      icon: 'file',
      tip: {
        chinese: '文档',
        english: 'document',
      },
      params: [
        { key: 'page', required: 'true', default: 1, type: 'query' },
        { key: 'subject', required: 'true', default: 'english', type: 'query' },
        { key: 'id', required: 'optional' },
      ],
    },
    {
      link: 'animation',
      icon: 'crown',
      tip: {
        chinese: '动画',
        english: 'animation',
      },
      params: [
        { key: 'page', required: 'true', default: 1, type: 'query' },
        { key: 'subject', required: 'true', default: 'english', type: 'query' },
        { key: 'id', required: 'optional' },
      ],
    },
  ],
};
